import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { Country } from "@/info/countries";
import { type LoginStep, type OtpMethod } from "@/info/login";
import { LogoWithName } from "@/svgs/logo-with-name";
import { trackEvent } from "@/utils/analytics/track-event";
import Link from "next/link";
import React from "react";
import { CountrySelector } from "./country-selector";
import { OtpInput } from "./otp-input";
import { OtpMethodSelector } from "./otp-method-selector";
import { PhoneInput } from "./phone-input";
import { ResendButton } from "./resend-button";

// Form content component that will be shared between dialog and sheet
export function LoginFormContent(t0) {
  const $ = _c(47);
  const {
    step,
    selectedCountry,
    setSelectedCountry,
    phoneNumber,
    setPhoneNumber,
    otpMethod,
    setOtpMethod,
    otp,
    setOtp,
    error,
    isLoading,
    handleSendOTP,
    handleVerifyOTP,
    handleBackToPhone,
    handleResendOTP,
    otpSentAt,
    handleKeyPress,
    isMobile: t1,
    isPreferencePage: t2
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const isPreferencePage = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== handleSendOTP || $[1] !== otpMethod) {
    t3 = () => {
      trackEvent({
        facebook: {
          event: "CompleteRegistration",
          options: {
            content_name: "Login Started",
            method: otpMethod
          }
        },
        google: {
          event: "sign_up",
          options: {
            method: otpMethod
          }
        },
        matomo: {
          event: "login-start",
          options: {
            category: "auth"
          }
        }
      });
      handleSendOTP();
    };
    $[0] = handleSendOTP;
    $[1] = otpMethod;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleSendOTPWithTracking = t3;
  let t4;
  if ($[3] !== handleVerifyOTP || $[4] !== otpMethod) {
    t4 = () => {
      trackEvent({
        facebook: {
          event: "CompleteRegistration",
          options: {
            content_name: "Login Completed",
            method: otpMethod
          }
        },
        google: {
          event: "login",
          options: {
            method: otpMethod
          }
        },
        matomo: {
          event: "login-complete",
          options: {
            category: "auth"
          }
        }
      });
      handleVerifyOTP();
    };
    $[3] = handleVerifyOTP;
    $[4] = otpMethod;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleVerifyOTPWithTracking = t4;
  const t5 = ` ${isMobile ? "px-4 pb-4" : "max-w-sm mx-auto"} w-full`;
  let t6;
  if ($[6] !== isMobile || $[7] !== isPreferencePage) {
    t6 = isMobile && !isPreferencePage && <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4" />;
    $[6] = isMobile;
    $[7] = isPreferencePage;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LogoWithName className="h-20 md:h-16 sm:h-8 w-auto mx-auto mb-3 text-primary" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <div className="text-center mb-6">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `${isMobile ? "text-lg" : "text-xl md:text-2xl"} font-bold text-gray-900`;
  const t10 = step === "phone" ? "Log in to continue" : "Verify your phone";
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <h2 className={t9}>{t10}</h2>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = step === "phone" ? "Enter your phone number to get started" : `We sent a code to ${selectedCountry.code} ${phoneNumber}`;
  let t13;
  if ($[15] !== t12) {
    t13 = <p className="text-sm text-gray-600 mt-2">{t12}</p>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t11 || $[18] !== t13) {
    t14 = <div className="text-center mb-6">{t11}{t13}</div>;
    $[17] = t11;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== error || $[21] !== handleBackToPhone || $[22] !== handleResendOTP || $[23] !== handleSendOTPWithTracking || $[24] !== handleVerifyOTPWithTracking || $[25] !== isLoading || $[26] !== otp || $[27] !== otpMethod || $[28] !== otpSentAt || $[29] !== phoneNumber || $[30] !== selectedCountry || $[31] !== setOtp || $[32] !== setOtpMethod || $[33] !== setPhoneNumber || $[34] !== setSelectedCountry || $[35] !== step) {
    t15 = step === "phone" ? <><CountrySelector selectedCountry={selectedCountry} onCountryChange={setSelectedCountry} isDisabled={isLoading} /><PhoneInput phoneNumber={phoneNumber} onPhoneNumberChange={setPhoneNumber} selectedCountry={selectedCountry} onEnterPress={handleSendOTPWithTracking} isDisabled={isLoading} /><OtpMethodSelector selectedMethod={otpMethod} onMethodChange={setOtpMethod} isDisabled={isLoading} countryCode={selectedCountry.countryCode} />{error && <p className="text-sm text-red-600 text-center">{error}</p>}<Button className="w-full h-12 font-semibold" onPress={handleSendOTPWithTracking} isDisabled={isLoading} variant="default">{isLoading ? <div className="flex items-center gap-2"><div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /><span>Sending...</span></div> : "Send OTP"}</Button></> : <><OtpInput otp={otp} onOtpChange={setOtp} onEnterPress={handleVerifyOTPWithTracking} isDisabled={isLoading} />{error && <p className="text-sm text-red-600 text-center">{error}</p>}<Button className="w-full h-12 font-semibold" onPress={handleVerifyOTPWithTracking} isDisabled={isLoading} variant="default">{isLoading ? <div className="flex items-center gap-2"><div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /><span>Verifying...</span></div> : "Verify OTP"}</Button><div className="flex flex-col sm:flex-row gap-2 pt-2"><Button variant="outline" className="flex-1 h-10 text-sm border-red-200 text-red-600 hover:bg-red-50 touch-manipulation" onPress={handleBackToPhone} isDisabled={isLoading}>Back</Button><ResendButton onResend={handleResendOTP} isLoading={isLoading} initialTimer={otpSentAt ? Math.max(0, 30 - Math.floor((Date.now() - otpSentAt) / 1000)) : 0} className="flex-1 h-10 text-sm border-red-200 text-red-600 hover:bg-red-50 touch-manipulation disabled:opacity-50" /></div></>;
    $[20] = error;
    $[21] = handleBackToPhone;
    $[22] = handleResendOTP;
    $[23] = handleSendOTPWithTracking;
    $[24] = handleVerifyOTPWithTracking;
    $[25] = isLoading;
    $[26] = otp;
    $[27] = otpMethod;
    $[28] = otpSentAt;
    $[29] = phoneNumber;
    $[30] = selectedCountry;
    $[31] = setOtp;
    $[32] = setOtpMethod;
    $[33] = setPhoneNumber;
    $[34] = setSelectedCountry;
    $[35] = step;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== handleKeyPress || $[38] !== t15) {
    t16 = <div className="space-y-4" onKeyDown={handleKeyPress}>{t15}</div>;
    $[37] = handleKeyPress;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Link href="/terms" className="text-red-600 hover:underline">Terms of Service</Link>;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="mt-6 text-center"><p className="text-xs text-gray-500">By continuing, you agree to our{" "}{t17}{" "}and{" "}<Link href="/privacy-policy" className="text-red-600 hover:underline">Privacy Policy</Link></p></div>;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t14 || $[43] !== t16 || $[44] !== t5 || $[45] !== t8) {
    t19 = <div className={t5}>{t8}{t14}{t16}{t18}</div>;
    $[42] = t14;
    $[43] = t16;
    $[44] = t5;
    $[45] = t8;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
}